import { render } from "./Workspaces.vue?vue&type=template&id=18644124&scoped=true"
import script from "./Workspaces.vue?vue&type=script&lang=js"
export * from "./Workspaces.vue?vue&type=script&lang=js"

import "./Workspaces.vue?vue&type=style&index=0&id=18644124&scoped=true&lang=css"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18644124"]])

export default __exports__